import { useState, useEffect } from 'react';
import { Form, Input, Button, message, Card, Divider } from 'antd';
import API from '../api/client';

const CtaPage = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    API.get('/cta').then((res) => { if (res.data && res.data._id) form.setFieldsValue(res.data); });
  }, [form]);

  const handleSave = async () => {
    setLoading(true);
    try {
      const values = await form.validateFields();
      await API.put('/cta', values);
      message.success('Kaydedildi');
    } catch { message.error('Hata oluştu'); }
    setLoading(false);
  };

  return (
    <>
      <h2>QR & Başvuru Ayarları</h2>
      <Card>
        <Form form={form} layout="vertical" style={{ maxWidth: 600 }}>
          <Divider>İş Başvurusu</Divider>
          <Form.Item name={['job', 'title']} label="Başlık"><Input /></Form.Item>
          <Form.Item name={['job', 'description']} label="Açıklama"><Input.TextArea rows={2} /></Form.Item>
          <Form.Item name={['job', 'buttonText']} label="Buton Metni"><Input /></Form.Item>
          <Form.Item name={['job', 'buttonLink']} label="Buton Linki"><Input /></Form.Item>
          <Form.Item name={['job', 'qrImage']} label="QR Görsel URL"><Input /></Form.Item>
          <Divider>Görüş / Şikayet</Divider>
          <Form.Item name={['feedback', 'title']} label="Başlık"><Input /></Form.Item>
          <Form.Item name={['feedback', 'description']} label="Açıklama"><Input.TextArea rows={2} /></Form.Item>
          <Form.Item name={['feedback', 'buttonText']} label="Buton Metni"><Input /></Form.Item>
          <Form.Item name={['feedback', 'buttonLink']} label="Buton Linki"><Input /></Form.Item>
          <Form.Item name={['feedback', 'qrImage']} label="QR Görsel URL"><Input /></Form.Item>
          <Button type="primary" onClick={handleSave} loading={loading}>Kaydet</Button>
        </Form>
      </Card>
    </>
  );
};

export default CtaPage;
